import {replaceMediaLikeTagsWithIds} from '@/common/questionPrintView/shared'

const buildOpenResponseQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const suggestedAnswerHtml = replaceMediaLikeTagsWithIds(content.suggested_answer || '')
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''
    const suggestedAnswerSectionHtml = suggestedAnswerHtml
        ? `<p>Suggested Answer:</p>${suggestedAnswerHtml}`
        : ''

    return `${questionSectionHtml}${suggestedAnswerSectionHtml}`
}

export {buildOpenResponseQuestionPrintView}
